import { config } from "./config";
import { styles } from "./styles";
export { config, styles };
